

export class VeriCacheInterceptor {

    httpTimeToLiveCache: [string, number] = [] as any;

    static Factory($cacheFactory: angular.ICacheFactoryService) {

        return new VeriCacheInterceptor($cacheFactory);
    }

    constructor(private $cacheFactory: angular.ICacheFactoryService) {
    }

    request = (config: angular.IRequestConfig) => {

        if (config.params) {
            var urlWithParams = this.createConfigWithUrl(config);

            if (config.params.invalidateCache) {
                this.invalidateCache(config);
            }
            else if (config.params.minsToLive) {

                config.cache = true;

                const n = config.params.minsToLive * 60 * 1000; // convert from minutes into milliseconds

                if (new Date().getTime() - (this.httpTimeToLiveCache[urlWithParams] as any || 0) > n) {
                    this.invalidateCache(config);
                }
            }
        }

        this.removeCacheVariables(config);

        return config;
    }

    private invalidateCache(config: angular.IRequestConfig) {
        var urlWithParams = this.createConfigWithUrl(config);
        this.removeCacheVariables(config);

        delete config.cache;

        this.$cacheFactory.get("$http").remove(urlWithParams);
        this.$cacheFactory.get("$http").remove(config.url);

        this.httpTimeToLiveCache[urlWithParams] = new Date().getTime();
    }

    private removeCacheVariables(config: angular.IRequestConfig) {
        if (config.params) {
            delete config.params.invalidateCache;
            delete config.params.minsToLive;
            //delete config.cache;
        }
    }

    private createConfigWithUrl(config: angular.IRequestConfig): string {
        var urlWithParams = config.url;

        if (!config.params) {
            return urlWithParams;
        }

        const keys = Object.keys(config.params);
        var keysToAppendToUrl = "";

        keys.forEach(x => {
            if (x == "minsToLive" || x == "invalidateCache" || x == "cache") {
                return;
            }

            if (keysToAppendToUrl.length > 0) {
                keysToAppendToUrl += "&";
            }

            keysToAppendToUrl += `${x}=${config.params[x]}`;
        });

        if (keysToAppendToUrl) {
            urlWithParams += "?" + keysToAppendToUrl;
        }

        return urlWithParams;
    }
}

VeriCacheInterceptor.Factory.$inject = ["$cacheFactory"];
